<script>
import CardImages from './CardImages.vue'
import CardCarcass from '../CardCarcass.vue'

export default {
  name: 'CardEmpty',
  components: { CardCarcass, CardImages },
  props: {
    text: {
      type: String,
      default: 'Интересантов пока нет',
    },
  },
  computed: {
    isMobileVersion() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    },
    cardClass() {
      return this.isMobileVersion ? 'mobile-card' : 'w-48'
    },
  },
}
</script>

<template>
  <CardCarcass>
    <div class="flex">
      <div :class="cardClass">
        <slot name="right">
          <CardImages
            image-url="https://cdn.winwinapp.ru/static/images/interesants/empty.svg"
          />
        </slot>
      </div>
      <div class="flex-1 pl-2 overflow-hidden">
        <slot name="left">
          <div
            class="h-full w-full flex items-center justify-center text-gray-700 font-bold text-xl"
          >
            {{ text }}
          </div>
        </slot>
      </div>
    </div>
  </CardCarcass>
</template>

<style scoped>
.mobile-card {
  width: 48%;
}
</style>
